import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {Wrapper, RewardIcon, Paragraph} from "./styled/StyledEmpty"

export default class EmptyRewards extends PureComponent {
  render() {
    return (
      <Wrapper>
        <RewardIcon />
        <Paragraph>
          <FormattedMessage id="recognition.account.reward.empty" />
        </Paragraph>
      </Wrapper>
    )
  }
}
